"use client";

import { useCurrentFrame, spring, useVideoConfig } from "remotion";

export default function GalleryGrid() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const cells = [
    { gradient: "linear-gradient(135deg, #3b82f6, #1d4ed8)", delay: 0 },
    { gradient: "linear-gradient(135deg, #a855f7, #7c3aed)", delay: 4 },
    { gradient: "linear-gradient(135deg, #4361ee, #3b82f6)", delay: 8 },
    { gradient: "linear-gradient(135deg, #7209b7, #a855f7)", delay: 12 },
    { gradient: "linear-gradient(135deg, #1d4ed8, #4361ee)", delay: 16 },
    { gradient: "linear-gradient(135deg, #7c3aed, #7209b7)", delay: 20 },
  ];

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "#111827",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        padding: "2rem",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gridTemplateRows: "1fr 1fr",
          gap: "1rem",
          width: "90%",
          height: "80%",
        }}
      >
        {cells.map((cell, i) => {
          const s = spring({
            frame: Math.max(frame - cell.delay, 0),
            fps,
            config: { damping: 12, stiffness: 100 },
          });

          const scale = 0.8 + s * 0.2;

          return (
            <div
              key={i}
              style={{
                background: cell.gradient,
                borderRadius: "10px",
                transform: `scale(${scale})`,
                opacity: s,
              }}
            />
          );
        })}
      </div>
    </div>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
